import { render, staticRenderFns } from "./Ficha.vue?vue&type=template&id=f5a3f156&"
import script from "./Ficha.vue?vue&type=script&lang=js&"
export * from "./Ficha.vue?vue&type=script&lang=js&"
import style0 from "./Ficha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports